import { errorHandler } from '../exports/error_management'
const AWS = require('aws-sdk')

const state = {
    resParams: {},
}

const getters = {}

const mutations = {
    set_resParams(state, resData) {
        state.resParams = resData
    },
}

const actions = {
    async retrieveSiteData({ dispatch, commit, rootState }, reqParams) {
        try {
            await dispatch('js_report/fetchCredentials', {}, { root: true })

            const {
                key: accessKeyId,
                secret: secretAccessKey,
                token: sessionToken,
                region,
            } = rootState.js_report.aws_credentials

            const options = {
                region,
                accessKeyId,
                secretAccessKey,
                sessionToken,
            }

            AWS.config.update(options)
            const lambda = new AWS.Lambda()

            const Payload = JSON.stringify({
                reqParams,
            })

            const params = {
                FunctionName: 'amsSiteUpload', //:prod',
                Payload,
            }

            const { Payload: resp } = await lambda.invoke(params).promise()

            const parsedResp = JSON.parse(resp)
            console.log('Lamda Store', parsedResp)
            commit('set_resParams', parsedResp)
        } catch (err) {
            errorHandler(err)
        }
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
